import Actions from './components/actions';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Sliders from './components/sliders';
import myParallax  from './components/parallax';

new Actions().init();
new Sliders().init();
new myParallax().init();

AOS.init({
    duration: 2000,
    once: true,
});
